import axios, { AxiosRequestConfig } from "axios";
import { currencyHeaderValue, readStoredCurrency } from "./currency";

interface CustomAxiosRequestConfig<TData> extends AxiosRequestConfig<TData> {
  withToken?: boolean;
  lang?: string;
}

export const request = async <TResponse = any, TData = any>({
  withToken = false,
  lang,
  ...options
}: CustomAxiosRequestConfig<TData>): Promise<TResponse> => {
  const baseURL = import.meta.env.VITE_API_URL ?? "";
  const client = axios.create({ baseURL });

  const language = lang || localStorage.getItem("i18nextLng") || "ar";
  client.defaults.headers.common["accept-language"] = language;

  const currency = readStoredCurrency();
  const currencyCode = currencyHeaderValue(currency);
  if (currencyCode) {
    client.defaults.headers.common["X-Currency"] = currencyCode;
  }

  return client({ ...options }).then((res) => res.data);
};
